import {Spin} from 'antd';
import styles from './collectionsUI.module.scss';
import {Button} from '@dabafinance/react-components';
import {NavTabsEnum} from 'utils/constants';
import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';
import {NavLink, Outlet, useNavigate} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {GET_ALL_COLLECTIONS} from 'graphql/queries/collections';
import {toast} from 'react-toastify';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const COLLECTION_SUBTABS = [
  {
    key: 'collections-list',
    to: '/dashboard/collections',
    name: 'Collections',
    end: true,
  },
  {
    key: 'collections-groups',
    to: '/dashboard/collections/groups',
    name: 'Groups',
  },
];

const Collection = () => {
  const navigate = useNavigate();

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.Collections),
  );

  const {visibleSubTabs} = useVisibleSubTabs(
    NavTabsEnum.Collections,
    COLLECTION_SUBTABS,
  );

  const {loading, data} = useQuery(GET_ALL_COLLECTIONS, {
    variables: {
      filters: {
        paginate: true,
      },
    },
    errorPolicy: 'all',
    onError: error => toast.error(error?.message),
  });

  const result = data?.adminGetAllCollections?.data;
  const collections = (result?.collections ?? []).filter(
    collection => !collection?.isDeleted,
  );
  const total = result?.pagination?.total ?? 0;
  const active = collections.filter(
    collection => collection?.status === 'Active',
  ).length;
  const constituents = collections.reduce(
    (sum, collection) => sum + (collection?.instrumentCount ?? 0),
    0,
  );

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1>Collections</h1>
          <p>
            Baskets of listed public equities an investor can buy in one order.
            Each collection belongs to a single exchange.
          </p>
        </div>
        <div className={styles.pageHeadActions}>
          <Button
            label="Create collection"
            disabled={!tabOperations?.create}
            onClick={() => navigate('/dashboard/collections/new')}
          />
        </div>
      </div>

      {loading ? (
        <div className={styles.loading}>
          <Spin size="large" />
          <h1>Loading collections…</h1>
        </div>
      ) : (
        <>
          <div className={styles.metrics}>
            <div className={styles.metric}>
              <span className={styles.metricLabel}>Collections</span>
              <span className={styles.metricValue}>{total}</span>
              <span className={styles.metricHint}>
                {active} active on this page
              </span>
            </div>
            <div className={styles.metric}>
              <span className={styles.metricLabel}>Constituents</span>
              <span className={styles.metricValue}>{constituents}</span>
              <span className={styles.metricHint}>
                across {collections.length} shown
              </span>
            </div>
            <div className={styles.metric}>
              <span className={styles.metricLabel}>Collection orders</span>
              <span className={styles.metricValue}>
                {(result?.collectionOrders ?? 0).toLocaleString()}
              </span>
              <span className={styles.metricHint}>all time</span>
            </div>
          </div>

          <nav className={styles.tabs}>
            {visibleSubTabs.map(tab => (
              <NavLink
                key={tab.key}
                to={tab.to}
                end={tab.end}
                className={({isActive}) => (isActive ? styles.tabActive : '')}>
                {tab.name}
              </NavLink>
            ))}
          </nav>

          <Outlet />
        </>
      )}
    </div>
  );
};

export {Collection};
